import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface FacetListSelectLabelProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children: JSX.Element
    childtestid?: string
}

const FacetListSelectLabel = memo(({templating, children, childtestid}: FacetListSelectLabelProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return (
        <Suspense>
            <ComponentName data-testid={childtestid}>{children}</ComponentName>
        </Suspense>
    )
})
FacetListSelectLabel.displayName = "FacetListSelectLabel"

export default connect(FacetListSelectLabel)
